var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { utilities } from "../utilities/utilities";
var MultiCarousel = /** @class */ (function () {
    function MultiCarousel(args) {
        this.items = args.items;
        this.itemTemplate = args.itemTemplate;
        this.header = args.header;
        this.tileWidth = 0;
        this.currentPage = 0;
        this.logicalStartIndex = 0;
        this.distanceToTile0 = 0;
        this.isTouchDevice = false;
    }
    Object.defineProperty(MultiCarousel.prototype, "carouselWrapper", {
        get: function () {
            return this.element.querySelector('.carousel-wrapper');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiCarousel.prototype, "headerWrapper", {
        get: function () {
            return this.element.querySelector('.header-wrapper');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiCarousel.prototype, "containerWidth", {
        get: function () {
            return this.trackWrapperElement.offsetWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiCarousel.prototype, "visibleCount", {
        get: function () {
            return Math.floor(this.containerWidth / this.tileWidth);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiCarousel.prototype, "totalPages", {
        get: function () {
            return Math.ceil(this.items.length / this.visibleCount);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiCarousel.prototype, "scrollCount", {
        get: function () {
            return (this.distanceToTile0 > 0 && this.distanceToTile0 < this.visibleCount) ? this.distanceToTile0 : this.visibleCount;
        },
        enumerable: false,
        configurable: true
    });
    MultiCarousel.prototype.reRenderTiles = function () {
        this.trackElement.innerHTML = '';
        for (var i = 0; i < this.items.length; i++) {
            var itemIndex = (this.logicalStartIndex + i) % this.items.length;
            var item = this.items[itemIndex];
            this.trackElement.appendChild(this.itemTemplate(item));
        }
    };
    MultiCarousel.prototype.scrollCarousel = function (direction) {
        var _this = this;
        this.currentPage = (this.currentPage + (direction === 'right' ? 1 : -1) + this.totalPages) % this.totalPages;
        // this.dost
        if (direction === 'right') {
            this.distanceToTile0 = (0 - this.logicalStartIndex + this.items.length) % this.items.length;
            this.logicalStartIndex = (this.logicalStartIndex + this.scrollCount) % this.items.length;
            /*  this.currentPage = (this.currentPage + 1 + this.totalPages) % this.totalPages;*/
            this.trackElement.style.transition = 'transform 0.4s ease';
            this.trackElement.style.transform = "translateX(-".concat(this.tileWidth * this.scrollCount, "px)");
            setTimeout(function () {
                _this.reRenderTiles();
                _this.trackElement.style.transition = 'none';
                _this.trackElement.style.transform = 'translateX(0)';
                _this.renderIndicators();
                _this.updateControlVisibility();
            }, 400);
        }
        else if (direction === 'left') {
            this.distanceToTile0 = (this.logicalStartIndex - 0 + this.items.length) % this.items.length;
            this.logicalStartIndex = (this.logicalStartIndex - this.scrollCount + this.items.length) % this.items.length;
            /* this.currentPage = (this.currentPage - 1 + this.totalPages) % this.totalPages;*/
            this.reRenderTiles();
            this.trackElement.style.transition = 'none';
            this.trackElement.style.transform = "translateX(-".concat(this.tileWidth * this.scrollCount, "px)");
            requestAnimationFrame(function () {
                _this.trackElement.style.transition = 'transform 0.4s ease';
                _this.trackElement.style.transform = 'translateX(0)';
                _this.renderIndicators();
                _this.updateControlVisibility();
            });
        }
    };
    MultiCarousel.prototype.updateControlVisibility = function () {
        if (!this.leftControl || !this.rightControl)
            return;
        // Show/hide left control based on position
        if (this.logicalStartIndex === 0) {
            this.leftControl.style.display = 'none';
        }
        else {
            this.leftControl.style.display = '';
        }
    };
    MultiCarousel.prototype.renderControls = function () {
        var _this = this;
        if (this.leftControl && this.rightControl)
            return;
        var createControl = function (direction) {
            var control = utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                <button style=\"z-index:1001; background:rgba(0,0,0,0.3)\" class=\"btn text-white ll-carousel-control position-absolute top-0 bottom-0 ", "\">\n                    <span class=\"fa-solid fa-2x fa-chevron-", "\"></span>\n                </button>\n            "], ["\n                <button style=\"z-index:1001; background:rgba(0,0,0,0.3)\" class=\"btn text-white ll-carousel-control position-absolute top-0 bottom-0 ", "\">\n                    <span class=\"fa-solid fa-2x fa-chevron-", "\"></span>\n                </button>\n            "])), direction == 'right' ? 'end-0' : 'start-0', direction);
            control.addEventListener('click', function () { return _this.scrollCarousel(direction); });
            return control;
        };
        this.leftControl = createControl('left');
        this.rightControl = createControl('right');
        this.carouselWrapper.append(this.leftControl, this.rightControl);
        this.updateControlVisibility();
        this.renderIndicators();
    };
    MultiCarousel.prototype.renderIndicators = function () {
        var _this = this;
        var _a;
        (_a = this.indicators) === null || _a === void 0 ? void 0 : _a.remove();
        this.indicators = null;
        if (this.totalPages <= 1)
            return;
        this.currentPage = Math.floor(this.logicalStartIndex / this.visibleCount);
        this.indicators = utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            <div class=\"carousel-indicators-wrapper\">\n                ", "\n            </div>\n        "], ["\n            <div class=\"carousel-indicators-wrapper\">\n                ", "\n            </div>\n        "])), Array.from({ length: this.totalPages }).map(function (element, i) { return utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    <span class=\"carousel-indicator-dot ", "\"></span>\n                "], ["\n                    <span class=\"carousel-indicator-dot ", "\"></span>\n                "])), i === _this.currentPage ? 'active' : ''); }));
        this.headerWrapper.appendChild(this.indicators);
    };
    MultiCarousel.prototype.addCarouselFeatures = function () {
        this.renderControls();
        this.renderIndicators();
    };
    MultiCarousel.prototype.removeCarouselFeatures = function () {
        var _a, _b, _c;
        (_a = this.rightControl) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.leftControl) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = this.indicators) === null || _c === void 0 ? void 0 : _c.remove();
        this.rightControl = null;
        this.leftControl = null;
        this.indicators = null;
    };
    MultiCarousel.prototype.updateTileMetrics = function () {
        var tile = this.trackElement.children[0];
        if (!tile)
            return;
        this.tileWidth = tile.offsetWidth + parseInt(getComputedStyle(tile).marginRight || '0');
    };
    MultiCarousel.prototype.updateCarousel = function () {
        function is_touch_enabled() {
            return (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
                matchMedia("(pointer: coarse)").matches);
        }
        this.isTouchDevice = is_touch_enabled();
        if (this.isTouchDevice) {
            var style = document.createElement('style');
            style.innerHTML = "\n                .carousel-track-wrapper {\n                  overflow-x: auto !important;\n                  -webkit-overflow-scrolling: touch !important;\n                  scrollbar-width: none !important;\n                }\n                .carousel-track-wrapper::-webkit-scrollbar {\n                  display: none !important;\n                }\n                .carousel-track {\n                  display: inline-flex !important;\n                  transition: none !important;\n                  will-change: scroll-position;\n                }\n              ";
            document.head.appendChild(style);
        }
        this.updateTileMetrics();
        var totalWidthOfTiles = this.items.length * this.tileWidth;
        var needsCarousel = totalWidthOfTiles > this.trackWrapperElement.offsetWidth;
        if (this.isTouchDevice) {
            this.trackElement.style.transition = 'none';
            this.trackElement.style.transform = 'none';
        }
        else {
            needsCarousel ? this.addCarouselFeatures() : this.removeCarouselFeatures();
        }
    };
    MultiCarousel.prototype.init = function () {
        var _this = this;
        setTimeout(function () {
            /*      this.updateTileMetrics();*/
            //const totalWidthOfTiles = this.items.length * this.tileWidth;
            //const needsCarousel = totalWidthOfTiles > this.trackWrapperElement.offsetWidth;
            /*if (needsCarousel) this.addCarouselFeatures();*/
            _this.updateCarousel();
            window.addEventListener('resize', function () { return _this.updateCarousel(); });
        }, 0);
    };
    MultiCarousel.prototype.render = function () {
        var _this = this;
        var tiles = this.items.map(function (p, index) {
            var tile = _this.itemTemplate(p, index);
            return tile;
        });
        this.trackElement = utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            <div class=\"carousel-track d-flex w-100\" style=\"transition: transform 0.4s ease;\">\n                ", "\n            </div>\n            \n        "], ["\n            <div class=\"carousel-track d-flex w-100\" style=\"transition: transform 0.4s ease;\">\n                ", "\n            </div>\n            \n        "])), tiles);
        this.trackWrapperElement = utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            <div class=\"carousel-track-wrapper\" style=\" width:100%;\">\n                ", "\n            </div>\n        "], ["\n            <div class=\"carousel-track-wrapper\" style=\" width:100%;\">\n                ", "\n            </div>\n        "])), this.trackElement);
        this.element = utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            <div class=\"d-flex flex-column gap-3 carousel-outer\">\n                <div class=\"header-wrapper\">\n                    ", "\n                </div>\n                <div class=\"carousel-wrapper\" style=\"position:relative; width:100%;\">\n                    ", "\n                </div>\n            </div>\n        "], ["\n            <div class=\"d-flex flex-column gap-3 carousel-outer\">\n                <div class=\"header-wrapper\">\n                    ", "\n                </div>\n                <div class=\"carousel-wrapper\" style=\"position:relative; width:100%;\">\n                    ", "\n                </div>\n            </div>\n        "])), this.header, this.trackWrapperElement);
        this.init();
        return this.element;
    };
    return MultiCarousel;
}());
export { MultiCarousel };
;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
